import SimpleLayout from "@/layouts/simple";
import { useSearchParams } from "@/routes/hooks";
import { Button } from "@/ui/button";
import { useOidc } from "@axa-fr/react-oidc";
import { useEffect, useState } from "react";
import { OidcErrorType } from "../errors";

const defaultErrorInfoState = { error: "", description: "" };

const AuthenticatingError = () => {
	const searchParams = useSearchParams();
	const oidc = useOidc();

	const [errorInfo, setErrorInfo] = useState(defaultErrorInfoState);

	useEffect(() => {
		const error = searchParams.get("error");
		const description = searchParams.get("error_description");

		if (error || description) {
			setErrorInfo({
				error: error || "",
				description: description || "",
			});
		} else {
			setErrorInfo(defaultErrorInfoState);
		}
	}, [searchParams]);

	const logout = async () => {
		await oidc.logout(`${window.location.origin}/auth/logout-callback`);
	};

	return (
		<SimpleLayout>
			<div className="oidc-authenticating">
				<div className="oidc-authenticating__container">
					<h1 className="oidc-authenticating__title">Error authentication</h1>
					<p className="oidc-authenticating__content">An error occurred during authentication.</p>
					{errorInfo.error && (
						<div>
							<div className="oidc-authenticating__error">
								<p className="oidc-authenticating__error-title">Error: {errorInfo.error}</p>
								{errorInfo.description && <p className="oidc-authenticating__error-description">{errorInfo.description}</p>}
							</div>
							{errorInfo.error === OidcErrorType.AccessDenied && <Button onClick={logout}>Log out</Button>}
						</div>
					)}
				</div>
			</div>
		</SimpleLayout>
	);
};

export { AuthenticatingError };
